import Immutable from 'immutable';

import TableSortPreferences from 'sharedreact/data/TableSortPreferences';
import SortOrder from 'sharedreact/data/SortOrder';

const Content: {
  selectedColumns: Immutable.Map<string, Immutable.Set<string>>,
  columnOrder: Immutable.Map<string, Immutable.List<string>>,
  columnWidths: Immutable.Map<string, Immutable.Map<string, string>>,
  sorting: Immutable.Map<string, TableSortPreferences>
} = {
  selectedColumns: Immutable.Map(),
  columnOrder: Immutable.Map(),
  columnWidths: Immutable.Map(),
  sorting: Immutable.Map()
};

class TablePreferences extends Immutable.Record(Content) {
  setSelectedColumns (tableName: string, selectedColumns: Immutable.Set<string>) {
    return this.set('selectedColumns', this.selectedColumns.set(tableName, selectedColumns));
  }

  mergeColumnWidths (tableName: string, columnWidths: Immutable.Map<string, string>) {
    let mergedColumnWidths = this.columnWidths.get(tableName);
    if (mergedColumnWidths == null) {
      mergedColumnWidths = Immutable.Map();
    }
    mergedColumnWidths = mergedColumnWidths.merge(columnWidths);

    return this.set('columnWidths', this.columnWidths.set(tableName, mergedColumnWidths));
  }

  setColumnOrder (tableName: string, columnOrder: Immutable.List<string>) {
    return this.set('columnOrder', this.columnOrder.set(tableName, columnOrder));
  }

  setTableSortOrder (tableName: string, sortOrder: SortOrder) {
    let prefs = this.sorting.get(tableName);
    if (prefs == null) {
      prefs = new TableSortPreferences();
    }
    prefs = prefs.set('activeKeyword', sortOrder.keyword).setAscending(sortOrder.keyword, sortOrder.ascending);

    return this.set('sorting', this.sorting.set(tableName, prefs));
  }
}

export default TablePreferences;
